import React,{ Component } from 'react';
import { Row, Col } from 'reactstrap';

import Button from '../../../shared/components/Button';

class HelpBestPractices extends Component {
  render(){
    return (
      <div>
        <Row>
          <Col xs='12'>
            <br />
            <Button download='https://storage.googleapis.com/adjoy-app-assets/static/dabbl-best-practices-v11.pdf'>
              Download Best Practices PDF
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}

export default HelpBestPractices;



// WEBPACK FOOTER //
// ./src/routes/HelpBestPractices/components/HelpBestPractices.js